import { Component, OnInit, Input } from '@angular/core';
import { Company } from '../../models/company';
import { Observable } from 'rxjs';
import { CompanyInfoStateService } from '../../services/company-info-state.service';

@Component({
  selector: 'app-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.css']
})
export class CompanyInfoComponent implements OnInit {


  constructor(
    private companyInfoStateService: CompanyInfoStateService,
  ) { }

  ngOnInit() {
    this.companyInfoStateService.initialize().subscribe();
  }

  get company() {
    return this.companyInfoStateService.companyInfo;
  }

  get name(): string {
    return this.company.alternate && this.company.alternate.name ? this.company.alternate.name : this.company.name;
  }

  get street(): string {
    return this.company.alternate && this.company.alternate.street ? this.company.alternate.street : this.company.street;
  }

  get zip(): number {
    return this.company.alternate && this.company.alternate.zip ? this.company.alternate.zip : this.company.zip;
  }

  get city(): string {
    return this.company.alternate && this.company.alternate.city ? this.company.alternate.city : this.company.city;
  }

  get country(): string {
    return this.company.alternate && this.company.alternate.country ? this.company.alternate.country : this.company.country;
  }

  get phone(): string {
    return this.company.alternate && this.company.alternate.phone ? this.company.alternate.phone : this.company.phone;
  }
}
